<template>
<div class="modal-wrap">
  <modal v-bind="{
    adaptive: true,
    draggable: false,
    resizable: false,
    clickToClose: false,
    width: '90%',
    height: 'auto',
    shiftY: 0.3,
    maxWidth: 800,
    ...modalAttrs,
    name: modalName,
  }">
    <slot></slot>
    <div v-if="mainButtonText || secondButtonText"
         class="btn-wrap">
      <button v-if="mainButtonText"
              class="main-btn"
              @click="mainClick">
        {{ mainButtonText }}
      </button>
      <button v-if="secondButtonText"
              class="second-btn"
              @click="secondClick">
        {{ secondButtonText }}
      </button>
    </div>
  </modal>
</div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal);

export default {
  name: 'DialogPanel',
  props: {
    modalName: String,
    mainButtonText: String,
    secondButtonText: String,
    modalAttrs: Object,
  },
  methods: {
    show() {
      this.$modal.show(this.modalName);
    },
    hide() {
      this.$modal.hide(this.modalName);
    },
    mainClick() {
      this.$emit('main-button-click')
    },
    secondClick() {
      this.$emit('second-button-click')
    }
  }
}
</script>

<style scoped>
.btn-wrap {
  margin-top: 1.5rem;
  text-align: right;
}
.btn-wrap button {
  border-radius: 0.3rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem 1.5rem;
  margin: 0.25rem;
  min-width: 8rem;
  text-align: center;
}
.main-btn {
  border: none;
  background-color: #333;
  color: white;
}
.second-btn {
  border: solid 1px #333;
  background-color: white;
  color: #333;
}
</style>
<style>
.vm--modal {
  border: solid 1px dimgray;
  border-radius: 1.5rem;
  background-color: white;
  padding: 3rem;
}
.vm--overlay {
  background: rgba(0, 0, 0, 0.5);
}
</style>
